module.exports = __webpack_public_path__ + "img/MTABAPPSPIRO.b56b0d7c.jpg";